import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, HostListener, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BlogService } from '@sparro/app/core/api/blog/blog.service';
import { MetaService } from '@sparro/app/core/helpers/meta/meta.service';

import { UniApiConfig } from '@sparro/app/core/config/api.config';
import { ALLOWED_HOSTS, UNI_CONSTANTS } from '@sparro/app/core/config/constants.config';
import { ImageOptimizerService } from '@sparro/app/core/helpers/image-optimizer';
import { Blog } from '@sparro/app/core/models/blog.model';
import { User } from '@sparro/app/core/models/user.model';
import { ConfirmationDialogComponent } from '@sparro/app/shared/components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { PreviewPaneComponent, PreviewPaneData } from '@sparro/app/shared/components/dialogs/preview-pane/preview-pane.component';
import { SnackbarService } from '@sparro/core/helpers/toastr/snackbar.service';
import { environment } from '@sparro/env/environment';

@Component({
  selector: 'uni-blog-card',
  templateUrl: './blog-card.component.html',
  styleUrls: ['./blog-card.component.scss']
})
export class BlogCardComponent implements OnInit, AfterViewInit {
  @Input() blog: Blog;
  @Input() host: ALLOWED_HOSTS;
  @Input() featured: boolean;
  @Input() self: boolean;
  @Input() showCardOptions: boolean;
  @Input() isDisplay: boolean;
  @Input() dialogOpenable: boolean = true;
  @Input() user: User;
  @Output() removed = new EventEmitter();
  
  showHeader: boolean = true;
  articleSchema: {[key: string]: any};
  cardWidth: number;

  @ViewChild ('blogCardContainer') blogCardContainer: ElementRef; 


  constructor(
    private imageOptimizer: ImageOptimizerService,
    public dialog: MatDialog,
    public router: Router,
    public route: ActivatedRoute,
    private blogService: BlogService,
    public snackbarService: SnackbarService,
    private _apiConfig: UniApiConfig,
    private metaService: MetaService
  ) { }

  ngOnInit() {
    if (
      this.host === UNI_CONSTANTS.HOSTS.EVALUATION ||
      this.host === UNI_CONSTANTS.HOSTS.BLOG ||
      (this.host === UNI_CONSTANTS.HOSTS.PROFILE && this.blog.status !== 'DRAFT' )
    ) {
      this.dialogOpenable = false;
    }
    
    if (this.host === UNI_CONSTANTS.HOSTS.BUILDER) {
      this.showHeader = false;
    }
    
    if (this.blog.author.id === this.user?.id) {
      this.self = true;
    }

    if (this.blog) {
      this.articleSchema = this.metaService?.createArticleSchema(this.blog);
    }
  }
  ngAfterViewInit() {
    this.cardWidth = this.blogCardContainer?.nativeElement.offsetWidth;
  }

  // @HostListener('window:scroll', [])
  
  @HostListener('window:resize', [])
  onWindowResize(): void {
    this.cardWidth = this.blogCardContainer?.nativeElement.offsetWidth;
  }

  renderImage(image: string, width, height): string {
    return this.imageOptimizer.renderImage(image, width, height);
  }

  getBlogDetailLink(): string {
    if (this.blog.slug) {
      return `${environment.postUrl}${this.blog.slug}`;
    } else if (this.self) {
      return `${environment.postUrl}edit/${this.blog.uuid}/`;
    }
  }

  openDialog(): void {
    const previewData: PreviewPaneData = {
      slug: this.blog.slug,
      entityType: this._apiConfig.blogUrl,
    };
    this.dialog.open(PreviewPaneComponent, {
      panelClass: 'custom-preview-pane',
      data: previewData
    });
  }

  delete(event): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: 'Are you sure you want to delete this journal?',
        okayButtonText: 'Yes'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
     if (result) {
        this.blogService.deleteBlog(this.blog.uuid).subscribe(
          (response: any) => {
            this.removed.emit(this.blog.uuid);
            this.snackbarService.success(`Journal: ${this.blog.title} has been deleted.`);
          }, (err) => {
            console.log(err);
            this.snackbarService.error(`Journal could not be deleted.`);
          }
        );
      }
    });
  }
}
